import React from 'react';
import { AKBetsMainLogoWrapper, AKBetsMainLogo } from './akbets.style';

export const AKBetsLogotype = (): JSX.Element => (
    <AKBetsMainLogoWrapper>
        <AKBetsMainLogo />
    </AKBetsMainLogoWrapper>
);
